import request from "../until/request";

export function carouselInit(data) {
    return request({
        url: "/supply/home/shopSetting",
        method: "GET",
        params: data,
    });
}

export function classify(data) {
    return request({
        url: "/supply/home/classify",
        method: "GET",
        params: data,
    });
}

export function recomclassify(data) {
    return request({
        url: "/supply/home/recommend/classify",
        method: "GET",
        params: data,
    });
}

export function MessageCode(data) {
    return request({
        url: "/supply/user/getMessageCode",
        method: "GET",
        params: data.value,
    });
}

export function nameverifyCode(data) {
    return request({
        url: "/supply/user/verifyCode",
        method: "GET",
        params: data.value,
    });
}

export function gologin(data) {
    return request({
        url: "/auth/login",
        method: "POST",
        data: data.value,
    });
}

export function forgetPassword(data) {
    return request({
        url: "/supply/user/forgetPassword",
        method: "POST",
        data: data.value,
    });
}

export function register(data) {
    return request({
        url: "/supply/user/register",
        method: "POST",
        data: data.value,
    });
}

export function getuserinfo(data) {
    return request({
        url: "/supply/user/info",
        method: "GET",
        params: data,
    });
}

export function searchRecord(data) {
    return request({
        url: "/supply/food/searchRecord",
        method: "GET",
        params: data,
    });
}

export function clearSearchRecord(data) {
    return request({
        url: "/supply/food/clearSearchRecord",
        method: "GET",
        params: data,
    });
}

export function updatePassword(data) {
    return request({
        url: "/supply/user/updatePassword",
        method: "POST",
        data: data.value,
    });
}